const someErrorTextMapping =(string)=> {
  if(string.includes('uk_device_uniqueid')){
    string = string.replace("uk_device_uniqueid", "IMEI");
  } else if(string.includes('uk_user_username')){
    string = string.replace("uk_user_username", "Username");
  } else if(string.includes('uk_user_email')){
    string = string.replace("uk_user_email", "Email");
  } 
}

export const prefixString = (prefix, value) => {
  return prefix + value.charAt(0).toUpperCase() + value.slice(1);
}

export const unprefixString = (prefix, value) => {
  return value.charAt(prefix.length).toLowerCase() + value.slice(prefix.length + 1);
}

export const filterErrorMessage =(errorMessage)=> {
  let message = 'Something wrong happened during call';
  if(errorMessage.includes(" - SecurityException")){
    message = errorMessage.slice(0, errorMessage.indexOf(" - SecurityException"));
  } else if(errorMessage.includes(" - MySQLIntegrityConstraintViolationException")){
    message = errorMessage.slice(0, errorMessage.indexOf(" - MySQLIntegrityConstraintViolationException"));
    message = someErrorTextMapping(message);
  } else if(errorMessage.includes(" - IllegalArgumentException")){
    message = errorMessage.slice(0, errorMessage.indexOf(" - IllegalArgumentException"));
  } else if(errorMessage.includes(" - RuntimeException")){
    message = errorMessage.slice(0, errorMessage.indexOf(" - RuntimeException"));
  } else if(errorMessage.includes(" - SQLIntegrityConstraintViolationException")){
    message = errorMessage.slice(0, errorMessage.indexOf(" - SQLIntegrityConstraintViolationException"));
  }
  return message;
}